<label [id]="id()" [for]="forId()" [class.error]="hasError()" [class.form-label]="true" [style.min-width]="minWidth()">
    {{ label() | translate }}
    @if (required()) {
        <span class="required-mark">*</span>
    }
    @if (tooltipText()) {
        <info-tooltip [id]="id() + '-tooltip'" [text]="tooltipText()" [iconClass]="infoTooltipClass()"></info-tooltip>
    }
</label>
